import React from 'react';
import ReactDOM from 'react-dom';
import * as yup from 'yup';
import App from './app';
import './index.scss';
import 'devextreme/dist/css/dx.light.css';

const EnvironmentConfigurationSchema = yup.object({
  apiBaseUrl: yup.string().required('Config entry NX_API_BASE_URL is missing'),
  expiresIn: yup.number().required('Config entry NX_INACTIVITY_TIMEOUT is missing'),
});

EnvironmentConfigurationSchema.validateSync({
  apiBaseUrl: process.env.NX_API_BASE_URL,
  expiresIn: process.env.NX_INACTIVITY_TIMEOUT,
});

ReactDOM.render(<App />, document.getElementById('root'));
